module.exports = __webpack_public_path__ + "static/media/Iveco.77a96dc7.jpeg";